// used to limit max horizontal / vertical aspect ratios for CMS provided images/videos
// max allowed horizontal aspect ratio is 16 /9
// max allowed vertical aspect ratio is 3 / 4
export const getBoundedAspectRatio = (
  width: number,
  height: number
): string => {
  const isVertical = width / height < 1;
  const sourceRatio = width / height;

  if (isVertical) {
    const maxVerticalAspRatio = 3 / 4;

    if (sourceRatio < maxVerticalAspRatio) return '3 / 4';
    else return `${width} / ${height}`;
  } else {
    const maxHorizontalAspRatio = 16 / 9;

    if (sourceRatio > maxHorizontalAspRatio) return '16 / 9';
    else return `${width} / ${height}`;
  }
};
